import { render, staticRenderFns } from "./room_quantity.vue?vue&type=template&id=5104f70a&"
import script from "./room_quantity.vue?vue&type=script&lang=js&"
export * from "./room_quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports